module.exports = __webpack_public_path__ + "img/liveback.fb15c1a8.png";